// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function Frame3Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 24 15"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M20.768 6.572H4.984l3.468-3.468a1.156 1.156 0 000-1.674 1.156 1.156 0 00-1.674 0l-5.5 5.5a1.156 1.156 0 000 1.675l5.5 5.5a1.156 1.156 0 001.674 0 1.156 1.156 0 000-1.674L4.984 8.964H20.77c.597 0 1.195-.479 1.195-1.196 0-.718-.598-1.196-1.195-1.196z"
        }
        fill={"currentColor"}
        opacity={".4"}
      ></path>
    </svg>
  )
}

export default Frame3Icon
/* prettier-ignore-end */
